import { NgModule } from '@angular/core';
import { MinutesPipe } from './minutes.pipe';

@NgModule({
  declarations: [MinutesPipe],
  imports: [],
  exports: [MinutesPipe],
})
export class MinutesPipeModule {}
